export const Constants = {
  azureBackend : 'azuread-oauth2',
  clientId: '31366030-6f4d-4b20-87ba-025563f2cecc',
  createOrderLanguageKey: 'createOrderLanguage',
  createOrderCountryKey: 'createOrderCountry',
  pusherAppKey: 'dad9b017a6c21a7bf903',
  pusherCluster: 'eu'
};
